import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { isEmpty } from 'underscore';
import useHomeStore from '../store/homeStore';
import useSearchStore from '../store/searchStore';

export const useHeaderPopup = () => {
  const navigate = useNavigate();

  const setShowSearch = useHomeStore((state) => state.setShowSearch);
  const setShowPricingModal = useHomeStore(
    (state) => state.setShowPricingModal
  );
  const setShowFeaturesModal = useHomeStore(
    (state) => state.setShowFeaturesModal
  );
  const setShowContactModal = useHomeStore(
    (state) => state.setShowContactModal
  );

  const setShowNotifications = useHomeStore(
    (state) => state.setShowNotifications
  );

  const setShowDownloadApiModal = useHomeStore(
    (state) => state.setShowDownloadApiModal
  );

  const setShowGetStartedModal = useHomeStore(
    (state) => state.setShowGetStartedModal
  );

  const setSearchId = useSearchStore((state) => state.setSearchId);

  const closeAllModals = useCallback(() => {
    setShowPricingModal(false);
    setShowSearch(false);
    setShowContactModal(false);
    setShowFeaturesModal(false);
    setShowGetStartedModal(false);
    setShowDownloadApiModal(false);
    setShowNotifications(false);
  }, [
    setShowContactModal,
    setShowDownloadApiModal,
    setShowFeaturesModal,
    setShowGetStartedModal,
    setShowNotifications,
    setShowPricingModal,
    setShowSearch,
  ]);

  const openModalByRoute = useCallback(
    (pageId: string, splitPath: string[]) => {
      closeAllModals();
      switch (pageId) {
        case 'metadata':
          if (!isEmpty(splitPath[1])) {
            setSearchId(splitPath[1]);
          }
          setShowSearch(true);
          break;
        case 'pricing':
          setShowPricingModal(true);
          break;
        case 'features':
          setShowFeaturesModal(true);
          break;
        case 'contact':
          setShowContactModal(true);
          break;
        case 'notifications':
          setShowNotifications(true);
          break;
        case 'api':
          setShowDownloadApiModal(true);
          break;
        case 'getstarted':
          setShowGetStartedModal(true);
          break;
        default:
          break;
      }
    },
    [
      closeAllModals,
      setSearchId,
      setShowContactModal,
      setShowDownloadApiModal,
      setShowFeaturesModal,
      setShowGetStartedModal,
      setShowNotifications,
      setShowPricingModal,
      setShowSearch,
    ]
  );

  const navigateToHome = useCallback(
    () => navigate({ pathname: '/', hash: '' }, { replace: true }),
    [navigate]
  );

  return {
    closeAllModals,
    openModalByRoute,
    navigateToHome,
  };
};
